import { createStore, compose, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import createRootReducer from './reducer';

export const history = createBrowserHistory();

function configureStore() {
    const store = createStore(
        createRootReducer( history ),
        compose(
            applyMiddleware(
                routerMiddleware( history ),
                thunk,
            ),
        )
    );

    return store;
}

export const store = configureStore();
